<div class="area-item" data-cy="area-list-item">
    <div class="placeholder"></div>
    <div class="item-content" (click)="onClickEvent()">
        @if (area().areaType === EvAreaType.PostcodeArea) {
            <div class="header">{{ area().number + " " + area().name }}</div>
        } @else {
            <div class="header">{{ area().name }}</div>
        }
        <div class="subtitle">{{ getMappedType(area().areaType) }}</div>
    </div>
    <div class="icon in-list" (click)="this.onRemove.emit(area())"></div>
</div>
